import { tireOrderingTestInstance } from '../axios';

const getStates = (country: string) => tireOrderingTestInstance.post('/sections/states', { country });

export default getStates;
